import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../store/actions/index';

import PieChart from '../../../Charts/PieChart';

const PieVentasMensualesPorEmpresa = (props) => {
 
  const handlePorcionClick = (config) => {
    props.onPorcionClick(config);
  };

  return (
    <PieChart
      title={props.title}
      subTitle={props.subtitle}
      series={props.ventas.map((venta) => venta.total)}
      labels={props.ventas.map((venta) => venta.nombreEmpresa)}
      ids={props.ventas.map((venta) => venta.id)}
      imgSinDatos={props.totalVentas <= 0}
      loading={props.loading}
      chartType={'pie'}
      height={props.height}
      width={'100%'}
      disabled={props.estaOculto}
      onPorcionClick={handlePorcionClick}
      onChangeViewClick={props.onChangeViewClick}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    ventas: state.multiempresa.ventasMensualesPorEmpresa.ventas,
    loading: state.multiempresa.ventasMensualesPorEmpresa.loading,
    estaCargado: state.multiempresa.ventasMensualesPorEmpresa.estaCargado,
    estaOculto: state.configuraciones.indicadoresOcultosPorUsuario.indicadores.ventasMensualesMultiempresa
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLoadChart: () => dispatch(actions.loadVentasMensualesMultiempresa())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PieVentasMensualesPorEmpresa);
